import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PDPAlertBarIcon from './PDPAlertBarIcon';
const PDPAlertBar = t0 => {
  const $ = _c(13);
  const {
    children,
    type: t1,
    className
  } = t0;
  const type = t1 === undefined ? "info" : t1;
  const t2 = type === "info";
  const t3 = type === "error";
  const t4 = !!className;
  let t5;
  if ($[0] !== className || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = classNames("py-4 flex items-center mt-8", {
      "bg-yellow-light": t2,
      "bg-red-light": t3,
      [className]: t4
    });
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== type) {
    t6 = <div className="px-6 flex justify-center items-center"><PDPAlertBarIcon type={type} /></div>;
    $[5] = type;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== children) {
    t7 = <div className="text-base pr-3 [&>a]:font-bold [&>a]:underline">{children}</div>;
    $[7] = children;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t6 || $[11] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
PDPAlertBar.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['info', 'error']),
  className: PropTypes.string
};
export default PDPAlertBar;